import Typography from 'antd/es/typography';
import React from 'react';
import styled from 'styled-components';

import {
  SectionHeader,
  SectionTitle,
} from '../../../components/TaskDescription';

const { Paragraph } = Typography;

const ContentSection = styled.div`
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }
`;

interface ErrorSectionProps {
  hasError: boolean;
}

const ErrorSection: React.FC<ErrorSectionProps> = ({ hasError }) => {
  if (!hasError) {
    return null;
  }

  return (
    <ContentSection>
      <SectionHeader>
        <SectionTitle level={4} type="danger" style={{ margin: 0 }}>
          Error
        </SectionTitle>
      </SectionHeader>
      <Paragraph type="danger">
        This agent run failed to complete successfully.
      </Paragraph>
    </ContentSection>
  );
};

export default ErrorSection;
